var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 67,
    viewBox: "0 0 45 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4881 38.0993V64.1851C37.4881 65.8901 35.5998 66.9167 34.1619 65.9974L27.7741 61.8908L22.3788 58.4205L16.981 61.8908L10.5931 65.9974C9.15787 66.9141 7.26953 65.8901 7.26953 64.1851V38.0993H37.4881Z",
    fill: "#F41943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7736 38.0993V61.8934L22.3783 58.4232L16.9805 61.8934V38.0993H27.7736Z",
    fill: "#EBF2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4875 38.0993V41.4622C35.4106 42.8948 32.0137 44.846 27.7734 45.8779V38.0993H37.4875Z",
    fill: "#C6123D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7749 38.0993V45.8779C25.9939 46.3127 24.0637 46.5824 22.0234 46.5824C20.2425 46.5824 18.5558 46.3729 16.9844 46.0272V38.102H27.7749V38.0993Z",
    fill: "#C3DBDA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.981 38.0994V46.0246C12.801 45.1001 9.43287 43.2065 7.26953 41.7084V38.0967H16.981V38.0994Z",
    fill: "#C6123D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3798 44.7596C34.7398 44.7596 44.7596 34.7398 44.7596 22.3798C44.7596 10.0198 34.7398 0 22.3798 0C10.0198 0 0 10.0198 0 22.3798C0 34.7398 10.0198 44.7596 22.3798 44.7596Z",
    fill: "#F9B906"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3815 42.7691C33.6422 42.7691 42.7708 33.6405 42.7708 22.3798C42.7708 11.1191 33.6422 1.99054 22.3815 1.99054C11.1208 1.99054 1.99219 11.1191 1.99219 22.3798C1.99219 33.6405 11.1208 42.7691 22.3815 42.7691Z",
    fill: "#E8A615"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5209 22.3798C41.5209 32.9346 32.9357 41.5224 22.3809 41.5224C19.3873 41.5224 16.5535 40.831 14.0288 39.6027C11.394 38.3194 9.09709 36.4494 7.30566 34.1655C6.48852 33.1232 5.77614 31.9917 5.18685 30.7896C3.94019 28.2517 3.23828 25.3943 3.23828 22.3798C3.23828 20.1432 3.62328 17.9981 4.33042 16.0024C6.45971 9.9891 11.5171 5.35076 17.7766 3.80028C19.2511 3.43362 20.7938 3.23981 22.3809 3.23981C25.9114 3.23981 29.2219 4.201 32.0635 5.87195C33.3312 6.61838 34.5045 7.50624 35.5652 8.51457C37.5635 10.416 39.1533 12.7443 40.1852 15.3529C41.0469 17.5293 41.5209 19.8996 41.5209 22.3798Z",
    fill: "#F9B906"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0635 5.87195L5.18685 30.7896C3.94019 28.2517 3.23828 25.3943 3.23828 22.3798C3.23828 20.1432 3.62328 17.9981 4.33042 16.0024L17.7766 3.80028C19.2511 3.43362 20.7938 3.23981 22.3809 3.23981C25.9114 3.23981 29.2219 4.19838 32.0635 5.87195Z",
    fill: "#FFC943"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1842 15.3529L14.0278 39.6027C11.393 38.3194 9.09612 36.4494 7.30469 34.1656L35.5642 8.51721C37.5626 10.416 39.1523 12.7444 40.1842 15.3529Z",
    fill: "#FFC943"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.836 32V18.112L17.868 18.588V14.808L25.344 13.688V32H20.836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinOne);
export default __webpack_public_path__ + "static/media/coin_one.a095590bfce36da41f480a4e280e7434.svg";
export { ForwardRef as ReactComponent };